export default __webpack_public_path__ + "static/media/chomito.7409e886.jpeg";